module.exports = __webpack_public_path__ + "img/146-gambia.fab16c83.svg";